export default Object.freeze({
  AmountPaid: 1,
  PlanMonthlyFee: 2,
  NetAfterDiscountBeforeTax: 3,
});
